import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Dialog, DialogContent, Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { useAppContext } from "../../../state/app/context";
import appLoadingProgressStyles from "../styles/AppLoadingProgress.styles";
import { useGameContext } from "../../../state/game/context";

const AppLoadingProgress = () => {
	const classes = appLoadingProgressStyles();
	const { state: appState } = useAppContext();
	const { state: gameState } = useGameContext();
	const isGameLoading = gameState.isLoading();
	const isLoading = appState.isLoading();

	return (
		<Dialog
			open={isLoading || isGameLoading}
			aria-labelledby="loading-dialog-title"
			aria-describedby="loading-dialog-description"
			fullScreen
			disableEscapeKeyDown
			transitionDuration={{
				appear: 0,
				enter: 0,
				exit: 1000
			}}
		>
			<DialogContent style={{ padding: "0px 0px 0px 0px" }}>
				<Box
					display="flex"
					justifyContent="center"
					flexDirection="column"
					spacing={2}
					alignItems="center"
					className={classes.container}
				>
					<CircularProgress className={classes.circularProgress} />
					<Typography variant="h3">Warming up...</Typography>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default AppLoadingProgress;
